export enum SpotlightCache {
  RECENTLY_VIEWED = 'recently_viewed'
}
